/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Lazy loading of the component PageSubscriberMobile
 *
 * @author Evgenij Tyan
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */
import loadable from '../../utils/loadable';

export default loadable(() => import(/* webpackChunkName: "PageSubscriberMobile" */ './PageSubscriberMobile'), undefined);
